import { dispatchManagerFeatures } from '../../featureFlags/dispatchManagerFeatures';
import { isQuantityDisplayRateType } from '../functions';
import { ShipmentStatusTypes } from './shipmentStatusTypes';

export const PER_MILE = 'PerMile';
export const PER_CWT = 'PerCWT';
export const FLAT = 'Flat';
export const PER_HEADCOUNT = 'PerHeadCount';
export const PER_TON = 'PerTon';
export const PER_BUSHEL = 'PerBushel';
export const NONE = 'None';
export const HEAD_COUNT = 'headCount';
export const QUANTITY = 'quantity';
export const PER_QUANTITY = 'Per Quantity';

export const getBaseRateTypes = (
    settingHeadCountOrQuantity: string,
    shipmentStatus?: string,
    invoicedDisplayRateTypeValue?: string | undefined,
): { label: string; value: string }[] => {
    const { isShowHeadCountOrQuantitySection } = dispatchManagerFeatures;
    const isPastLoads = shipmentStatus === ShipmentStatusTypes.pastLoads;
    const isQuantity = isQuantityDisplayRateType(
        isShowHeadCountOrQuantitySection,
        isPastLoads,
        settingHeadCountOrQuantity,
        invoicedDisplayRateTypeValue,
    );
    const types = [
        { label: 'Select Rate Type', value: NONE },
        { label: 'Per Mile', value: PER_MILE },
        { label: 'Per CWT', value: PER_CWT },
        { label: 'Flat', value: FLAT },
        { label: 'Per Ton', value: PER_TON },
        { label: 'Per Bushel', value: PER_BUSHEL },
        {
            label: isQuantity ? PER_QUANTITY : 'Per Head Count',
            value: PER_HEADCOUNT,
        },
    ];
    return types;
};
